import { BasicConfig } from '@shared/models/basic-config.interface';

export abstract class JobsConfig extends BasicConfig {
  privileges: {
    jobs: {
      featured: string;
      hiringManager: string;
    };
    reports: {
      view: string;
    };
  };
}

export type JobsPrivileges = JobsConfig['privileges'];
